import { titleMedium, screenMdMin, titleSmall, screenLgMin, titleLarge, Text, bodyMediumBold, } from '@spotify-internal/encore-web/core';
import React from 'react';
import styled from 'styled-components';
import { responsiveText, formatText } from '../utils';
const Paragraph = styled(Text) `
  ${responsiveText(bodyMediumBold, {
    '1440px': titleSmall,
})};
`;
const Tagline = styled(Text) `
  ${responsiveText(titleMedium, {
    [screenMdMin]: titleSmall,
    [screenLgMin]: titleMedium,
    '1440px': titleLarge,
})};
`;
export const BodyText = ({ isTagline, tagline, paragraph, hasCta = false, }) => {
    if (isTagline) {
        return (React.createElement(Tagline, { className: "tagline", hasCta: hasCta, dangerouslySetInnerHTML: {
                __html: formatText(tagline),
            } }));
    }
    return (React.createElement(Paragraph, { className: "paragraph", hasCta: hasCta, dangerouslySetInnerHTML: {
            __html: formatText(paragraph),
        } }));
};
